/* eslint-disable react/prop-types */ // TODO: add props
import QuestionView from './QuestionView';
import ReflectionView from './ReflectionView';

export const ShortAnswerQuestion = (props) =>
  !props.response ? <QuestionView {...props} /> : <ReflectionView {...props} />;
